export function getEndDate() {
  const date = new Date;
  date.setDate(date.getDate() + 30);
  date.setHours(23, 59, 0);
  return date;
}
